import { t } from "@/i18n-js/instance";
import { Row } from "@/react/components/shared/uikit/SkeletonLoader";
import { Switch } from "@circle-react-uikit/Switch";
import { Typography } from "@circle-react-uikit/Typography";

const I18N_LOCALE_ROOT =
  "settings.billing.upgrade_modal_plan_details_with_proration" as const;

interface BillingToggleProps {
  customText?: string;
  isAnnualPlan: boolean;
  isInactive?: boolean;
  isLoading?: boolean;
  onChange: (value: boolean) => void;
}

export const BillingToggle = ({
  isAnnualPlan,
  isLoading = false,
  onChange,
  isInactive = false,
  customText,
}: BillingToggleProps) => {
  if (isLoading) {
    return <Row md className="h-9 w-48 rounded-full" />;
  }

  return (
    <button
      type="button"
      className={`inline-flex w-fit cursor-pointer items-center gap-3 rounded-full border px-1.5 py-1 ${
        isInactive
          ? "border-gray-300 bg-gray-100 dark:border-gray-600 dark:bg-gray-700"
          : "border-green-400/50 bg-green-100/50 dark:border-green-600 dark:bg-green-200"
      }`}
      onClick={() => onChange(!isAnnualPlan)}
      aria-pressed={isAnnualPlan}
    >
      <Switch checked={isAnnualPlan} onChange={onChange} as="div" />
      <Typography.LabelXs
        color={isInactive ? "text-gray-500" : "text-green-600"}
        weight="medium"
      >
        {customText || t(`${I18N_LOCALE_ROOT}.billing_toggle.annual_savings`)}
      </Typography.LabelXs>
    </button>
  );
};
